<div class="cb-horizontal-navigation-wrapper">

    <ng-container *ngFor="let item of navigation">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <cb-horizontal-navigation-basic-item
                class="cb-horizontal-navigation-menu-item"
                *ngIf="item.type === 'basic'"
                [item]="item"
                [name]="name"></cb-horizontal-navigation-basic-item>

            <!-- Branch: aside, collapsable, group -->
            <cb-horizontal-navigation-branch-item
                class="cb-horizontal-navigation-menu-item"
                *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'"
                [item]="item"
                [name]="name"></cb-horizontal-navigation-branch-item>

            <!-- Spacer -->
            <cb-horizontal-navigation-spacer-item
                class="cb-horizontal-navigation-menu-item"
                *ngIf="item.type === 'spacer'"
                [item]="item"
                [name]="name"></cb-horizontal-navigation-spacer-item>

        </ng-container>

    </ng-container>

</div>
